export default {
  // VGCAL_API_GAMES_ENDPOINT: 'http://localhost:8000/api/releases/',
  // VGCAL_API_FAVORITES_ENDPOINT: 'http://localhost:8000/api/favorites/',
  VGCAL_API_GAMES_ENDPOINT: 'https://stormy-cliffs-47713.herokuapp.com/api/releases/',
  VGCAL_API_FAVORITES_ENDPOINT: 'https://stormy-cliffs-47713.herokuapp.com/api/favorites/',
  API_KEY: process.env.REACT_APP_API_KEY,
}
